var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "high-risk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GloepidOne",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "high-risk",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Icon-BG",
    fill: "#FEAD9A",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    id: "Polaris-icon/Major/2-Tone/Circle-Disabled",
    transform: "translate(5.000000, 5.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Fill",
    cx: 9,
    cy: 9,
    r: 9
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14,4 C8.486,4 4,8.486 4,14 C4,19.514 8.486,24 14,24 C19.514,24 24,19.514 24,14 C24,8.486 19.514,4 14,4 M14,22 C9.589,22 6,18.411 6,14 C6,9.589 9.589,6 14,6 C18.411,6 22,9.589 22,14 C22,18.411 18.411,22 14,22 M14,15 C14.553,15 15,14.553 15,14 L15,10 C15,9.447 14.553,9 14,9 C13.447,9 13,9.447 13,10 L13,14 C13,14.553 13.447,15 14,15 M14,16.9004 C13.393,16.9004 12.9,17.3924 12.9,18.0004 C12.9,18.6074 13.393,19.0994 14,19.0994 C14.607,19.0994 15.1,18.6074 15.1,18.0004 C15.1,17.3924 14.607,16.9004 14,16.9004",
    id: "Mask",
    fill: "#BF0711"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighRisk);
export default __webpack_public_path__ + "static/media/high-risk.9bb5878cb37612273cc1b08528a8e77b.svg";
export { ForwardRef as ReactComponent };